export default () => ({
  component: 'providers-type-filter',
  componentAttrs: {
    clearable: true,
    'persistent-border': true,
  },
});
